import React from 'react';
import CmsItemListSection from '../../shared/cmsPage/components/CmsItemListSection';
import CmsPage from '../../shared/cmsPage/components/CmsPage';
import { selectConfig } from '../../store/rootSelectors';
import subtenantApi from '../api/subtenantApi';
import { SubtenantConstants } from '../definitions';
import useSubtenantActions from '../hooks/useSubtenantActions';

const SubtenantListPage = () => {
  const config = selectConfig();
  const showAffiliation = config?.enableSubtenantAffiliation || false;
  const affLabel = config?.messages?.['cms.manageSubtenants.affiliationLabel'];
  const affiliationLabel = showAffiliation && affLabel ? affLabel : 'Affiliation';
  const { toolbarActions, itemActions, SubtenantModal } = useSubtenantActions(showAffiliation);
  const columns = [
    { initialSort: 'ASC', label: 'Name', sortable: true, valueField: 'name' },
    ...(showAffiliation
      ? [
          {
            label: affiliationLabel,
            sortable: true,
            valueField: 'affiliation',
          },
        ]
      : []),
    {
      label: 'Is Default',
      sortable: true,
      valueField: 'isDefault',
      renderer: (item) => (item.isDefault ? 'True' : 'False'),
    },
  ];
  return (
    <>
      <CmsPage title="Subtenants">
        <CmsItemListSection
          showTotal
          pageId={SubtenantConstants.defaultPageId}
          typeName="Subtenants"
          toolbarActions={toolbarActions}
          itemActions={itemActions}
          columns={columns}
          itemApi={subtenantApi}
          searchPlaceholder="Search by Name"
        />
        {SubtenantModal}
      </CmsPage>
    </>
  );
};

export default SubtenantListPage;
